import { NFLookupCatalog } from "./NFLookupCatalog";
import { AppEntities } from "../../../config/entities";
import { NFLookupCatalogColumn } from "./NFLookupCatalogColumn";

interface IProps {
  title?: string;
  fieldName: string;
  required?: boolean;
  showBorder?: boolean;
  companyId?: string;
  divisionId?: string;
  width?: number;
  selectedCatalog?: boolean;
  setSelectedCatalog?: (value: boolean) => void;
}

export const NFLookupVendorSettlementAnalytics = ({ title, fieldName, required, showBorder, divisionId, companyId, width, selectedCatalog, setSelectedCatalog }: IProps) => {
  const loadData = async (searchText: string | undefined) => {
    return await AppEntities.VendorSettlementAnalytics.getDataService().GetAllFilteredByCompanyAndDivision(searchText, companyId, divisionId);
  };

  return (
    <>
      <NFLookupCatalog
        fieldName={fieldName}
        title={title}
        entity={AppEntities.VendorSettlementAnalytics}
        serverData={loadData}
        required={required}
        showBorder={showBorder}
        width={width}
        selectedCatalog={selectedCatalog}
        setSelectedCatalog={setSelectedCatalog}
      >
        <NFLookupCatalogColumn fieldName={"id"} caption={"Id"} />
        <NFLookupCatalogColumn fieldName={"name"} caption={"Name"} />
      </NFLookupCatalog>
    </>
  );
};
